/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useContext } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { Tag } from 'primereact/tag';
import { classNames } from 'primereact/utils';

import ImageComponent from 'shared/ImageComponent';
import NotesCreate from './NotesCreate.jsx';
import constants from 'constants/index';
import { UserDetailsContext } from 'context/userDetailsContext';
import { handleRedirection } from 'utils/utils';
import { convertDateFromApiToUserTimezone } from 'utils/utility_functions/timezone';
import { getLocalStorageParseItem, removeLocalStorageItem } from 'utils/localStorageUtils';

import { ReactComponent as OutgoingIcon } from 'assets/svg/outgoing_call.svg';
import { ReactComponent as IncomingIcon } from 'assets/svg/incoming_call.svg';
import { ReactComponent as FilesIcon } from 'assets/svg/files.svg';
import { useCaseNotes } from '../hooks/useCaseNotes.jsx';
import GlobalLoader from 'components/GlobalLoader/GlobalLoader.jsx';
import Filter from './Filter.jsx';
import { useCaseListFilter as useFilter } from '../hooks/useCaseListFilter.jsx';
import useIsInitialRender from 'hooks/useIsInitialRender.jsx';
import DescriptionWithToggle from './DescriptionWithToggle.jsx';
import ResizableDataTable from 'components/ResizableDataTable/ResizableDataTable.jsx';
import useAutomatedTime from 'hooks/useAutomatedTime.jsx';
import { generateFullName } from 'utils/generateFullNameUtils.js';
import useCompanionCase from '../hooks/useCompanionCase.jsx';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';

const Notes = ({ isLeadSpecific, caseDetails, isFormDashboard, isFromCaseSpecificModule }) => {
  const { case_id } = caseDetails || {};
  const { id } = useParams();
  const isGlobal = !Boolean(id);
  const history = useHistory();
  const location = useLocation();
  const { userDetails } = useContext(UserDetailsContext);
  const isInitialRender = useIsInitialRender();
  const { companionList } = useCompanionCase(case_id || id);
  const { onMountUnMount, onOperationBreak } = useAutomatedTime(caseDetails?.case_id, caseDetails?.case_description?.case_name);

  const { filterDebounced, filter, filterOnChange } = useFilter({});
  const { caseNoteList, paginatorTemplate, loadCaseNoteList } = useCaseNotes(
    { ...filter, case_id: case_id || id || '' },
    undefined,
    isLeadSpecific,
    isFromCaseSpecificModule
  );

  const [show, setShow] = useState(false);

  useEffect(() => {}, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const type = params.get('type');
    const companionLinkParam = params.get('companion_link');
    const validTypes = ['case_note', 'call_log'];
    if (validTypes.includes(type)) {
      const companion_link = companionLinkParam === 'true';
      setShow({ type, companion_link });
    }
  }, [location.search]);

  useEffect(() => {
    if (isInitialRender) {
      loadCaseNoteList({
        pagination_direction: localStorage.getItem('pagination_direction_notes') || '',
        pagination_token: localStorage.getItem('pagination_token_notes') || '',
      });
    } else {
      loadCaseNoteList({});
    }
  }, [filterDebounced]);

  useEffect(() => {
    const caseNoteDetails = location?.state?.caseNoteData || getLocalStorageParseItem('stateData')?.caseNoteData;
    if (caseNoteDetails) {
      removeLocalStorageItem('stateData');
    }
  }, [location, isFormDashboard]);

  const titleTemplate = (rowData) => {
    return (
      <React.Fragment>
        <span className="p-column-title text-break">Title</span>
        <div className="d-flex">
          <span className="notes-icons me-2 flex-shrink-0">
            {rowData?.note_type === 'case_note' ? (
              <FilesIcon width={18} height={18} className="me-2 files-icon" />
            ) : rowData?.note_type === 'call_log' && rowData?.call_type === 'outgoing' ? (
              <OutgoingIcon width={18} height={18} className="me-2 call-icon" />
            ) : rowData?.note_type === 'call_log' && rowData?.call_type === 'incoming' ? (
              <IncomingIcon width={18} height={18} className="me-2 call-icon" />
            ) : null}
          </span>
          <div style={{ minWidth: 0, flexGrow: 1 }}>
            {rowData?.title ? (
              <>
                <Link
                  to={`/${caseDetails?.is_lead ? 'leads' : 'cases'}/${caseDetails?.case_id}/notes/${rowData?.case_note_id}`}
                  state={rowData}
                  className="text-decoration-none d-block mt-1"
                >
                  <span className="redirection-link-no-text-transform text-bold ellipsis-text d-block" title={rowData?.title}>
                    {rowData.title}
                  </span>
                </Link>
                {rowData.note_type === 'call_log' ? (
                  <>
                    {rowData?.call_type === 'incoming' && (
                      <p className="text-hint mb-0 d-flex align-items-center">
                        <span className="text-nowrap me-1 flex-shrink-0">Call From:</span>
                        <Link
                          to={`/contacts/${rowData?.called_by ? rowData?.called_by?.client_id : rowData?.caller_name?.client_id}`}
                          className="d-flex flex-grow-1 text-decoration-none"
                          style={{ minWidth: 0 }}
                        >
                          <div
                            className="d-flex flex-grow-1 text-truncate"
                            title={generateFullName(rowData?.called_by ? rowData?.called_by : rowData?.caller_name) || '-'}
                          >
                            <Tag
                              className="p-mr-1 tag-case break-spaces"
                              value={generateFullName(rowData?.called_by || rowData?.caller_name) || '-'}
                              rounded
                            />
                          </div>
                        </Link>
                      </p>
                    )}

                    {rowData?.call_type === 'outgoing' && (
                      <p className="text-hint d-flex align-items-center mb-0">
                        <span className="text-nowrap me-1 flex-shrink-0">Called To:</span>
                        <Link
                          to={`/contacts/${rowData?.person_called?.client_id}`}
                          className="d-flex flex-grow-1 text-decoration-none"
                          style={{ minWidth: 0 }}
                        >
                          <div className="d-flex flex-grow-1 text-truncate" title={generateFullName(rowData?.person_called) || '-'}>
                            <Tag
                              className="p-mr-1 tag-case break-spaces"
                              value={rowData?.person_called ? generateFullName(rowData?.person_called) : '-'}
                              rounded
                            />
                          </div>
                        </Link>
                      </p>
                    )}
                  </>
                ) : null}
              </>
            ) : null}
            {rowData?.description && <DescriptionWithToggle htmlContent={rowData?.description} />}
          </div>
        </div>
      </React.Fragment>
    );
  };

  const statusTemplate = (rowData) => {
    let statusTag;
    if (rowData?.resolution_status && !rowData?.resolved_status) {
      statusTag = (
        <div className="blue-tag">
          <p className="blue-tag-value text-nowrap">Needs Resolution</p>
        </div>
      );
    } else if (rowData?.resolution_status && rowData?.resolved_status) {
      statusTag = (
        <div className="green-tag">
          <p className="green-tag-value text-nowrap">Resolved</p>
        </div>
      );
    } else {
      statusTag = <span>-</span>;
    }
    return (
      <>
        <span className="p-column-title text-break">Status</span>
        {statusTag}
      </>
    );
  };

  const createdTemplate = (rowData) => {
    const firstName = rowData?._created_by_?._created_by_first_name_ || '';
    const lastName = rowData?._created_by_?._created_by_last_name_ || '';
    const name = firstName || lastName ? `${firstName} ${lastName}`.trim() : '-';
    const url = rowData?.created_by_firm_user_id
      ? `/settings/team-management/${rowData?.created_by_firm_user_id}`
      : '/settings/team-management';
    return (
      <>
        <span className="p-column-title text-break">Created</span>
        <span className="text-break d-inline-table">
          <span className="">
            {convertDateFromApiToUserTimezone(rowData?.created_time, userDetails.timezone, constants.month_date_year_time_12_format)}
          </span>
          <Link
            className={classNames(
              'text-muted small tbl-avatar d-flex align-items-center text-decoration-none text-primary-dark text-decoration-none case-details-link',
              {
                'cursor-pointer': rowData?._created_by_?._created_by_first_name_ || rowData?._created_by_?._created_by_last_name_,
              }
            )}
            to={url}
          >
            {rowData?.created_by_firm_user_id && <i className="fas fa-user-tie ps-0 me-2"></i>}
            <span>{name}</span>
          </Link>
        </span>
      </>
    );
  };

  const updatedTemplate = (rowData) => {
    const firstName = rowData?._updated_by_?._updated_by_first_name_ || '';
    const lastName = rowData?._updated_by_?._updated_by_last_name_ || '';
    const name = firstName || lastName ? `${firstName} ${lastName}`.trim() : '-';
    const filePath = rowData?.update_by_name?.length ? rowData.update_by_name.at(-1)['profile_image'] : '';
    const url = rowData?.updated_by_firm_user_id
      ? `/settings/team-management/${rowData?.updated_by_firm_user_id}`
      : '/settings/team-management';
    return (
      <>
        <span className="p-column-title text-break">Updated</span>
        <span className="text-break d-inline-table">
          <span className="">
            {convertDateFromApiToUserTimezone(rowData?.time, userDetails.timezone, constants.month_date_year_time_12_format)}
          </span>
          <Link
            className={classNames(
              'text-muted small tbl-avatar d-flex align-items-center text-decoration-none text-primary-dark text-decoration-none case-details-link',
              {
                'cursor-pointer': rowData?._updated_by_?._updated_by_first_name_ || rowData?._updated_by_?._updated_by_last_name_,
              }
            )}
            to={url}
          >
            {filePath && <ImageComponent filePath={filePath} fileName={name} fileSize="medium.jpg" avatarSize="medium" />}
            {rowData?.created_by_firm_user_id && (firstName || lastName) && <i className="fas fa-user-tie me-2"></i>}
            <span>{name}</span>
          </Link>
        </span>
      </>
    );
  };

  const caseBody = (rowData, ...rest) => {
    const { case_id, is_lead } = rowData;
    const mainModuleName = is_lead ? '/leads' : '/cases';
    let route = case_id ? `${mainModuleName}/${case_id}` : mainModuleName;

    return (
      <React.Fragment>
        <span className="p-column-title text-break">Case</span>
        <span
          onClick={(e) => handleRedirection(history, route)}
          className="redirection-link-no-text-transform"
          title={rowData.case_name ? rowData.case_name : undefined}
        >
          {rowData.case_name ? rowData.case_name : '-'}
        </span>
      </React.Fragment>
    );
  };

  return (
    <>
      <GlobalLoader />
      {Boolean(show) && (
        <NotesCreate
          setShow={setShow}
          noteType={show?.type}
          companionLink={show?.companion_link}
          fetchCaseNotes={loadCaseNoteList}
          isLeadSpecific={isLeadSpecific}
          caseDetails={caseDetails}
          isFromCaseSpecificModule={isFromCaseSpecificModule}
          isFromDashboard={isGlobal}
          onMountUnMount={onMountUnMount}
          onOperationBreak={onOperationBreak}
          companionList={companionList}
        />
      )}
      <Filter {...{ filterOnChange, filter, setShow, hasCompanion: companionList?.length > 0, caseDetails }} />
      <div className="row">
        <div className="col-12">
          <div className="datatable-responsive">
            <ResizableDataTable
              value={caseNoteList}
              responsiveLayout="scroll"
              className="p-datatable-responsive"
              emptyMessage="No Data Found."
              paginator
              paginatorTemplate={paginatorTemplate}
              stripedRows
              columns={[
                { field: 'title', header: 'Title', body: titleTemplate, sortable: true, bodyClassName: 'ellipsis-text' },
                {
                  field: 'case_name',
                  header: 'Case',
                  body: caseBody,
                  clickable: true,
                  clickableKey: 'case_id',
                  sortable: true,
                  bodyClassName: 'ellipsis-text',
                  hidden: caseDetails,
                },
                {
                  field: 'resolution_status',
                  header: 'Status',
                  body: statusTemplate,
                  sortable: true,
                  bodyClassName: 'ellipsis-text notes-status',
                },
                { field: '_created_by_', header: 'Created', body: createdTemplate, sortable: true, bodyClassName: 'ellipsis-text' },
                { field: '_updated_by_', header: 'Updated', body: updatedTemplate, sortable: true, bodyClassName: 'ellipsis-text' },
              ]}
              storageKey="case_notes_column_widths"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Notes;
